import React, { useState } from 'react';
import { Box, SimpleGrid, Heading, Text, Button, Image, HStack, Badge } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FiClock, FiUser } from 'react-icons/fi';
import {useAppData} from '../../store/dataStore';

const MotionBox = motion(Box);

const articles = [
  {
    id: 1,
    title: "Getting Ready for the AI World: A Beginner's Roadmap",
    excerpt: "Start your AI journey with this comprehensive guide.",
    category: "Guides",
    author: "John Doe",
    readTime: "8 min",
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=600"
  },
  {
    id: 2,
    title: "2026 Job Outlook: Which AI Roles Will Boom?",
    excerpt: "Discover the most in-demand AI careers for the future.",
    category: "Career Advice",
    author: "Jane Smith",
    readTime: "6 min",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600"
  },
  {
    id: 3,
    title: "5 GenAI Projects to Build This Weekend",
    excerpt: "Hands-on tutorials for practical AI applications.",
    category: "Tutorials",
    author: "Alex Kumar",
    readTime: "12 min",
    image: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=600"
  },
  {
    id: 4,
    title: "From Marketing to AI Developer: Anika's Journey",
    excerpt: "A inspiring career transition story.",
    category: "Career Advice",
    author: "Anika Patel",
    readTime: "7 min",
    image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=600"
  },
  {
    id: 5,
    title: "Understanding Neural Networks for Beginners",
    excerpt: "Demystifying the core concepts of deep learning.",
    category: "Guides",
    author: "Michael Chen",
    readTime: "10 min",
    image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=600"
  },
  {
    id: 6,
    title: "AI Ethics: What Every Developer Should Know",
    excerpt: "Navigate the ethical landscape of AI development.",
    category: "Industry Trends",
    author: "Sarah Johnson",
    readTime: "9 min",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600"
  }
];

const BlogGrid = ({ searchQuery, selectedCategory }) => {
  const { appData } = useAppData();
  const { studentsCount } = appData;
  const [visibleCount, setVisibleCount] = useState(6);

  const filteredArticles = articles.filter(article => {
    const matchesSearch = article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         article.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'All' || article.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <Box>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
        {filteredArticles.slice(0, visibleCount).map((article, index) => (
          <MotionBox
            key={article.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            bg="white"
            borderRadius="xl"
            overflow="hidden"
            boxShadow="md"
            _hover={{ transform: 'translateY(-4px)', boxShadow: 'lg' }}
          >
            <Image
              src={article.image}
              alt={article.title}
              h="200px"
              w="full"
              objectFit="cover"
            />
            <Box p={6}>
              <Badge colorScheme="green" mb={2}>{article.category}</Badge>
              <Heading as="h3" size="md" mb={2} color="brand.800" fontFamily="heading">
                {article.title}
              </Heading>
              <Text color="brand.500" mb={4} fontSize="sm">
                {article.excerpt}
              </Text>
              <HStack spacing={3} mb={4} color="brand.400" fontSize="xs">
                <HStack>
                  <FiUser />
                  <Text>{article.author}</Text>
                </HStack>
                <HStack>
                  <FiClock />
                  <Text>{article.readTime}</Text>
                </HStack>
              </HStack>
              <Button variant="outline" size="sm" w="full">
                Read Article
                {/* GA: article_read */}
              </Button>
            </Box>
          </MotionBox>
        ))}
      </SimpleGrid>

      {filteredArticles.length > visibleCount && (
        <Box textAlign="center" mt={8}>
          <Button
            variant="solid"
            size="lg"
            onClick={() => setVisibleCount(prev => prev + 6)}
          >
            Load More Articles
          </Button>
        </Box>
      )}

      {filteredArticles.length === 0 && (
        <Box textAlign="center" py={12}>
          <Heading size="md" color="brand.500">No articles found</Heading>
          <Text color="brand.400" mt={2}>Try adjusting your search or filters</Text>
        </Box>
      )}
    </Box>
  );
};

export default BlogGrid;
